import * as THREE from "three";
import {
   threeGeomInstanceFragShader,
  threeGeomInstanceVertShader,
} from "../shaders/threeGeomInstanceShader.js";
import mapboxgl from "mapbox-gl";
import {getScalingFactor} from "../helpers.js";
const earthRadius = 1303.797293808806;
import Stats from "three/examples/jsm/libs/stats.module.js";
import {getPlateIndex, roundDownToNearest5} from "../helpers/index.js";

const anchor = [30, 30];

let statsPanels;

const plates = [];
const plateSize = 5;

const latMin = -90;
const latMax = 90;
const lngMin = -180;
const lngMax = 180;


export const threeGeomLayer = {
  id: 'three-geom-layer', type: 'custom', renderingMode: '3d',

  onAdd(map, gl) {

    for (let lat = latMin; lat < latMax; lat += plateSize) {
      for (let lng = lngMin; lng < lngMax; lng += plateSize) {
        const swLat = lat;
        const swLng = lng;
        const neLat = Math.min(lat + plateSize, latMax);
        const neLng = Math.min(lng + plateSize, lngMax);

        plates.push({
          coords:[[swLat, swLng], [neLat, neLng]],
          plate: new mapboxgl.LngLatBounds(
            [ swLng, swLat],
            [ neLng, neLat]
          )
        });
      }
    }
    // console.log("plates.length", plates.length)

    this.map = window.map = map;

    const stats1 = new Stats();
    stats1.showPanel(0);
    document.body.appendChild(stats1.dom);

    const stats2 = new Stats();
    stats2.showPanel(1);
    stats2.dom.style.left = '80px';
    document.body.appendChild(stats2.dom);

    const stats3 = new Stats();
    stats3.showPanel(2);
    stats3.dom.style.left = '160px';
    document.body.appendChild(stats3.dom);
    statsPanels = [stats1, stats2, stats3];


    this.camera = new THREE.Camera();
    this.scene = new THREE.Scene();

    this.size = 0.005;
    this.space = 800;


    const box = new THREE.BoxGeometry(this.size, this.size, this.size);

    box.applyMatrix4(new THREE.Matrix4().makeTranslation(0, 0, this.size / 2));



    // ONE PLATE, 256 across x 162 down
    // 16 plates per row
    const plateArray = new Float32Array(162 * 16 * 16);


    plates.forEach(({ plate, coords }, i) => {
      const nw_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getNorthWest(), 0);
      const sw_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getSouthWest(), 0);
      const ne_merc = mapboxgl.MercatorCoordinate.fromLngLat(plate.getNorthEast(), 0);


      const tl_up = new THREE.Vector3().fromArray(plate.getNorthWest().toEcef(0));
      const br_up = new THREE.Vector3().fromArray(plate.getSouthWest().toEcef(0));
      const tr_up = new THREE.Vector3().fromArray(plate.getNorthEast().toEcef(0));
      const bl_up = new THREE.Vector3().fromArray(plate.getSouthEast().toEcef(0));


      const tl =  new THREE.Vector3(nw_merc.x, nw_merc.y, nw_merc.z);
      const tr =  new THREE.Vector3(ne_merc.x, ne_merc.y, ne_merc.z);
      const bl =  new THREE.Vector3(sw_merc.x, sw_merc.y, sw_merc.z);


      const offset = i * 16;

      plateArray.set([
        tl.x,
        tl.y,
        tr.x,
        bl.y,

        tl_up.x, tl_up.y, tl_up.z,
        tr_up.x, tr_up.y, tr_up.z,
        br_up.x, br_up.y, br_up.z,
        bl_up.x, bl_up.y, bl_up.z
      ], offset);
    });


    const plateTexture = new THREE.DataTexture(
      plateArray,
      256, 162,
      THREE.RedFormat,
      THREE.FloatType
    );
    plateTexture.needsUpdate = true;



    this.material = new THREE.ShaderMaterial({
      uniforms: {
        'u_matrix_globe_merc': { value: new THREE.Matrix4() },
        'u_plates': { value: plateTexture },
        'u_plate_height': { value: 0 },
        'u_plate_width': { value: 0 },
        'u_plate_up_scale': { value: 0 },
        'u_zoom_transition': { value: 0 },
        'u_centerInMerc': { value: new THREE.Vector2() },
        'u_pixelsPerMeterRatio': { value: 0 },
        'u_scale_factor': { value: 0 },
        'u_colour': { value: new THREE.Vector3(Math.random(), Math.random(), Math.random()) },
        'u_crossed_dateline': {value: false},
        'u_near_dateline': {value: false},
      },
      vertexShader: threeGeomInstanceVertShader,
      fragmentShader: threeGeomInstanceFragShader,
      depthTest: true,
      depthWrite: true,
      depthFunc: THREE.LessEqualDepth,
    });



    this.mesh = new THREE.InstancedMesh(box, this.material,  plates.length * 25);


    const instanceCount = plates.length * 25;
    const plateIndexi = new Float32Array(instanceCount);

    this.mesh.frustumCulled = false;    //hmm!
    // this.mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
    this.models = [];

    let i = 0;



    map.on("load", () => {

      map.addLayer({
        id: 'line-bounding-box',
        type: 'line',
        paint: {
          'line-color': '#3386c0',
          'line-width': 3,
          'line-opacity': 0.9
        },
        source: {
          type: 'geojson',
          data: {
            'type': 'Feature',
            'properties': {},
            'geometry': {
              'type': 'Polygon',
              'coordinates': [
                [
                  [175, -5],
                  [180, -5],
                  [180, 0],
                  [175, 0],
                  [175, -5]
                ]
              ]
            }
          }
        }
      });
    });



    for (let ii = 0; ii < plates.length; ii += 1) {

        const SW = plates[ii].coords[0];
        const NE = plates[ii].coords[1];




        const model = {
          x: SW[1]+5, y:  SW[0]+5
        };


          if(true) {
          // if ((model.y > -5) && model.y < 1
          //   && (model.x > 175
          //     // || model.x < -160
          //   )
          // ) {


            this.models.push(model);
            const mc = mapboxgl.MercatorCoordinate.fromLngLat([model.x, model.y], 0);
            const scale = mc.meterInMercatorCoordinateUnits() * 100;

            const matrix = new THREE.Matrix4()
              .makeRotationAxis(new THREE.Vector3(0, 0, 1), Math.random() * Math.PI)
              .premultiply(new THREE.Matrix4().makeTranslation(mc.x, mc.y, mc.z));

            this.mesh.setMatrixAt(i, matrix);

            this.mesh.setColorAt(i, new THREE.Color(1, 0, 0));

            const roundedDown = roundDownToNearest5(model);


            plateIndexi[i] = getPlateIndex(roundedDown);

            i++;
          }


    }



    const plateIndexAttribute = new THREE.InstancedBufferAttribute(plateIndexi, 1, false);
    this.mesh.geometry.setAttribute("plateIndex", plateIndexAttribute);


    this.mesh.instanceMatrix.needsUpdate = true;
    this.mesh.instanceColor.needsUpdate = true;

    this.mesh.computeBoundingBox();
    this.mesh.computeBoundingSphere();

    this.scene.add(this.mesh);

    this.renderer = new THREE.WebGLRenderer({
      canvas: map.getCanvas(), context: gl, antialias: true
    });

    this.renderer.autoClear = false;

    this.renderer.render(this.scene, this.camera);

  },

  render(gl, projectionMatrix, projection, globeToMercMatrix, transition, centerInMercator, pixelsPerMeterRatio) {

    statsPanels.forEach(stats => stats.begin());





    const u = this.material.uniforms;



    const mapCenter = this.map.getCenter();
    const nearDateLine = mapCenter.lng > 100 ||  mapCenter.lng < -100;
    const crossedDateLine = mapCenter.lng > 0;


    u.u_crossed_dateline.value = crossedDateLine;
    u.u_near_dateline.value = nearDateLine;


      this.models.forEach((model, i) => {
        if (nearDateLine) {
          if (model.x > -10 && model.x < 10) {

            const hiddenMatrix = new THREE.Matrix4()
              .makeScale(0, 0, 0);
            this.mesh.setMatrixAt(i, hiddenMatrix);
          }
        } else {

          if (model.x > -10 && model.x < 10) {

            const mc = mapboxgl.MercatorCoordinate.fromLngLat([model.x, model.y], 0);

            const matrix = new THREE.Matrix4()
              .premultiply(new THREE.Matrix4().makeTranslation(mc.x, mc.y, mc.z));

            this.mesh.setMatrixAt(i, matrix);
          }
        }
        this.mesh.instanceColor.needsUpdate = true;
        this.mesh.instanceMatrix.needsUpdate = true;
      });



    u.u_scale_factor.value = getScalingFactor(anchor[1]);
    u.u_plate_up_scale.value = earthRadius;



    if (projection && projection.name === 'globe') {


      u.u_zoom_transition.value = transition;
      u.u_pixelsPerMeterRatio.value = pixelsPerMeterRatio;
      u.u_matrix_globe_merc.value.fromArray(globeToMercMatrix);
      u.u_centerInMerc.value.fromArray(centerInMercator);

    } else {
      u.u_zoom_transition.value = 1;
    }

    this.renderer.clearDepth();

    this.camera.projectionMatrix.fromArray(projectionMatrix);   //[Merc to World] [World to Camera] [Camera to Clip]

    this.renderer.resetState();
    this.renderer.render(this.scene, this.camera);
    statsPanels.forEach(stats => stats.end());
  }

}




function lngLatToNormalizedMercator(lng, lat) {
  let x = (lng + 180) / 360;

  let radLat = (lat * Math.PI) / 180;
  let y = (1 - Math.log(Math.tan(radLat) + 1 / Math.cos(radLat)) / Math.PI) / 2;

  return { x, y };
}

function normalizedMercatorToLngLat(x, y) {
  let lng = x * 360 - 180;

  let lat = Math.atan(Math.sinh(Math.PI * (1 - 2 * y))) * (180 / Math.PI);

  return { lng, lat };
}


function normalizedMercToLngLat(x, y) {
  // Convert normalized Mercator x to longitude
  const longitude = x * 360 - 180;

  // Convert normalized Mercator y to latitude
  const lat_rad = Math.atan(Math.sinh(Math.PI * (1 - 2 * y))) * 180 / Math.PI;

  return [longitude, lat_rad];
}

